<template>
    <fragment>
        <div class="max-w-screen-xl px-4 pt-6 mx-auto sm:px-6">
            <nav
                class="relative flex items-center justify-between sm:h-10 md:justify-center"
            >
                <div
                    class="flex items-center flex-1 md:absolute md:inset-y-0 md:left-0"
                >
                    <div
                        class="flex items-center justify-between w-full md:w-auto"
                    >
                        <router-link :to="{ name: 'Home' }">
                            <h1
                                class="w-auto h-8 text-3xl font-black text-blue-600 sm:h-10"
                            >
                                CRIms
                                <span class="text-2xl font-normal"
                                    >BusinessPlan</span
                                >
                            </h1>
                        </router-link>
                        <div class="flex items-center -mr-2 md:hidden">
                            <button
                                @click="open = false"
                                type="button"
                                class="inline-flex items-center justify-center p-2 text-gray-400 transition duration-150 ease-in-out rounded-md hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500"
                            >
                                <svg
                                    class="w-6 h-6"
                                    stroke="currentColor"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M4 6h16M4 12h16M4 18h16"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                <div
                    class="hidden md:absolute md:flex md:items-center md:justify-end md:inset-y-0 md:right-0"
                >
                    <div class="hidden md:block">
                        <router-link
                            :to="{ name: 'Home' }"
                            class="font-medium font-bold text-blue-600 transition duration-150 ease-in-out border-b-2 border-blue-600 hover:text-blue-800 focus:outline-none focus:text-blue-600"
                            >Accueil</router-link
                        >
                        <router-link
                            target="_blank"
                            :to="{ name: 'guide_pratique' }"
                            class="ml-10 font-medium text-blue-600 transition duration-150 ease-in-out hover:text-blue-800 focus:outline-none focus:text-blue-600"
                            >Guide Pratique</router-link
                        >
                        <a
                            target="_blank"
                          href="https://www.marrakechinvest.ma/"
                            class="ml-10 font-medium text-blue-600 transition duration-150 ease-in-out hover:text-blue-800 focus:outline-none focus:text-blue-600"
                            >CRI</a
                        >
                        <a
                            href="mailto:bp@crimarrakech.ma"
                            class="ml-10 font-medium text-blue-600 transition duration-150 ease-in-out hover:text-blue-800 focus:outline-none focus:text-blue-600"
                            >Contact</a
                        >
                    </div>
                    <span
                        v-if="auth"
                        class="inline-flex hidden ml-6 rounded-md shadow md:block"
                    >
                        <span
                            class="inline-flex items-center px-10 py-2 text-base font-medium leading-6 text-blue-600 transition duration-150 ease-in-out bg-white border border-white cursor-pointer hover:text-blue-500 focus:outline-none focus:shadow-outline-blue active:bg-gray-50 active:text-blue-700"
                            @click="nextLink"
                            >{{ buttonTitle }}</span
                        >
                    </span>
                    <span
                        v-if="auth"
                        class="inline-flex hidden ml-6 rounded-md shadow md:block"
                    >
                        <span
                            @click="logout"
                            class="inline-flex items-center px-10 py-2 text-base font-medium leading-6 text-blue-600 transition duration-150 ease-in-out bg-white border border-white cursor-pointer hover:text-blue-500 focus:outline-none focus:shadow-outline-blue active:bg-gray-50 active:text-blue-700"
                            ><span class="mr-2">Déconnexion</span>
                            <svg
                                class="w-6 h-6"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                                ></path>
                            </svg>
                        </span>
                    </span>
                    <span
                        v-if="!auth"
                        class="inline-flex hidden ml-6 rounded-md shadow md:block"
                    >
                        <router-link
                            class="inline-flex items-center px-10 py-2 text-base font-medium leading-6 text-blue-600 transition duration-150 ease-in-out bg-white border border-white hover:text-blue-500 focus:outline-none focus:shadow-outline-blue active:bg-gray-50 active:text-blue-700"
                            :to="{ name: 'rm', query: { inscription: true } }"
                            >Inscription</router-link
                        >
                    </span>
                    <span
                        v-if="!auth"
                        class="inline-flex hidden ml-6 rounded-md shadow md:block"
                    >
                        <router-link
                            class="inline-flex items-center px-10 py-2 text-base font-medium leading-6 text-blue-600 transition duration-150 ease-in-out bg-white border border-white hover:text-blue-500 focus:outline-none focus:shadow-outline-blue active:bg-gray-50 active:text-blue-700"
                            :to="{ name: 'rm' }"
                            >connexion</router-link
                        >
                    </span>
                </div>
            </nav>
        </div>

        <div
            v-show="open"
            style="display: none;"
            class="absolute inset-x-0 top-0 p-2 md:hidden"
        >
            <div
                class="transition origin-top-right transform rounded-lg shadow-md"
                v-show="open"
            >
                <transition
                    enter-active-class="transition-all duration-150 ease-out"
                    leave-active-class="transition-all duration-150 ease-in"
                    enter-class="scale-95 opacity-0"
                    enter-to-class="scale-100 opacity-100"
                    leave-class="scale-100 opacity-100"
                    leave-to-class="scale-95 opacity-0"
                >
                    <div class="overflow-hidden bg-white rounded-lg shadow-xs">
                        <div
                            class="flex items-center justify-between px-5 pt-4"
                        >
                            <div>
                                <img
                                    class="w-auto h-8"
                                    src="/img/logos/workflow-mark-on-white.svg"
                                    alt
                                />
                            </div>
                            <div class="-mr-2">
                                <button
                                    @click="open = false"
                                    type="button"
                                    class="inline-flex items-center justify-center p-2 text-gray-400 transition duration-150 ease-in-out rounded-md hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500"
                                >
                                    <svg
                                        class="w-6 h-6"
                                        stroke="currentColor"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div class="px-2 pt-2 pb-3">
                            <a
                                href="#"
                                class="block px-3 py-2 text-base font-medium text-blue-600 transition duration-150 ease-in-out rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-100"
                                >Accueil</a
                            >
                            <a
                                href="#"
                                class="block px-3 py-2 mt-1 text-base font-medium text-gray-700 transition duration-150 ease-in-out rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50"
                                >Guide Pratique</a
                            >
                            <a
                                href="#"
                                class="block px-3 py-2 mt-1 text-base font-medium text-gray-700 transition duration-150 ease-in-out rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50"
                                >CRI</a
                            >
                            <a
                                href="#"
                                class="block px-3 py-2 mt-1 text-base font-medium text-gray-700 transition duration-150 ease-in-out rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50"
                                >Contact</a
                            >
                        </div>
                        <div>
                            <a
                                href="#"
                                class="block w-full px-8 py-4 font-medium text-center text-blue-600 transition duration-150 ease-in-out bg-gray-50 hover:bg-gray-100 hover:text-blue-700 focus:outline-none focus:bg-gray-100 focus:text-blue-700"
                                >Inscription</a
                            >
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </fragment>
</template>

<script>
import isEmpty from "lodash/isEmpty";
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            open: false,
            auth: false,
            buttonTitle: "",
            uid: ""
        };
    },
    created() {
        this.init();
        this.$store.watch(
            state => {
                return state.user.user;
            },
            () => {
                this.init();
            }
        );
    },
    methods: {
        init() {
            if (this.isAuth) {
                this.auth = true;
                if (this.user.bpis.length === 0) {
                    this.buttonTitle = "Créer Votre BPI";
                } else {
                    this.buttonTitle = "Mon BPI";
                    this.uid = this.user.bpis[0].id;
                }
            }
        },
        logout() {
            this.$store.dispatch("Auth/signOut");
        },
        nextLink() {
            if (this.buttonTitle === "Créer Votre BPI") {
                this.$router.push({
                    name: "business_plan_version",
                    params: { uid: `${this.$store.state.user.bpiId}` }
                });
            } else if (this.buttonTitle === "Mon BPI") {
                this.$router.push({
                    name: `${this.$store.state.user.currentStep}`,
                    params: { uid: `${this.uid}` }
                });
            }
        }
    },
    computed: {
        ...mapGetters("user", { user: "getUser" }),
        isAuth() {
            return !isEmpty(this.user);
        }
    }
};
</script>

<style></style>
